/** @jsxImportSource @emotion/react */
import React, {useState, useEffect} from "react";
import {useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";

// Images
import logo from "../assets/logo_white.png";

// Libs
import {primaryColor} from "../common/libs/theme-lib";

// Components
import Navigation from "./navigation";
import HeaderActions from "./header-actions";

// Hooks
import useAppRoutes from "../common/hooks/use-app-routes";

const Header = () => {

    // Hooks
    const {t} = useTranslation("header");
    const {pathname} = useLocation();
    const routesMetaData = useAppRoutes();
    const isPrivateRoute = !["login", "welcome", "reset-password", "forgot"].some(routeName => routeName === pathname.split("/")[1]);

    // State
    const [isAdminHeader, setIsAdminHeader] = useState(false);

    // Set isAdmin header state when route changes
    useEffect(() => {
        const actualRoute = routesMetaData.find(route => route.to === pathname);
        if (actualRoute && actualRoute.isAdminRoute !== isAdminHeader) {
            setIsAdminHeader(actualRoute.isAdminRoute);
        }
    }, [pathname]);

    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: isAdminHeader ? "black" : primaryColor,
            maxHeight: 100,
            minHeight: 100
        }}>
            <img
                src={logo}
                alt="Logo"
                height={70}
                style={{margin: "0 36px"}}
            />
            {isPrivateRoute && (
                <Navigation isAdminHeader={isAdminHeader} />
            )}
            {isPrivateRoute && (
                <HeaderActions
                    isAdminHeader={isAdminHeader}
                    setIsAdminHeader={setIsAdminHeader}
                />
            )}
            {!isPrivateRoute && (
                <div style={{
                    flex: 1,
                    textAlign: "right",
                    marginRight: 36,
                    color: "white",
                    fontSize: 18,
                    fontWeight: 100
                }}>
                    {t("public-text")}
                </div>
            )}
        </div>
    );
};

export default Header;